// extracted by mini-css-extract-plugin
export var companyAddress = "VenueSwitch-module--companyAddress--TgY1u";
export var container = "VenueSwitch-module--container--CMhlr";
export var containerMobile = "VenueSwitch-module--containerMobile--7OU2q";
export var hasOptions = "VenueSwitch-module--hasOptions--jpKHg";
export var selectedItem = "VenueSwitch-module--selectedItem--QSi+3";